<div *ngFor="let subscriptionCanvas of venueService.subscriptionMenu.value">
	<app-subscription-menu-menu-items [canvas]="subscriptionCanvas"></app-subscription-menu-menu-items>
</div>
